import React, { useState } from 'react';
import {
    IconContentCopy,
    withTooltip,
    TOOLTIP_HORIZONTAL_ALIGNMENTS,
    THEMES,
    TOOLTIP_VERTICAL_ALIGNMENTS
} from 'cdk-radial';

const YET_TO_COPY = 'Copy to clipboard';
const COPIED = 'Copied to clipboard';
const FAILED_TO_COPY = 'Failed to copy';
const DEFAULT_COLOR = 'rgba(21, 27, 37, 0.7)';

export const CopyToClipboard = props => {
    const { textToCopy = '', size = 24, fill={DEFAULT_COLOR} } = props;
    const [tooltipText, setTooltipText] = useState(YET_TO_COPY);
    const tooltipProps = {
        id: 'copy-icon-tooltip',
        'data-testid': 'copy-tooltip',
        text: tooltipText,
        delay: 0,
        theme: THEMES.LIGHT
    };

    const handleIconClick = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setTooltipText(COPIED)
        } catch (err) {
            console.error(FAILED_TO_COPY, err);
            setTooltipText(FAILED_TO_COPY);
        }
    }

    const handleMouseEnter = () => {
        setTooltipText(YET_TO_COPY);
    }

    const ComponentToRender = props => {
        return (
            <IconContentCopy
                data-testid='icon-copy'
                style={{ cursor: 'pointer', fill}}
                fill={fill}
                height={size}
                width={size}
                onClick={handleIconClick}
                onMouseEnter={handleMouseEnter}
                {...props}
            />
        );
    };
    const ComponentWithTooltip = withTooltip(ComponentToRender, tooltipProps);
    return (
        <ComponentWithTooltip
            horizontalAlignment={TOOLTIP_HORIZONTAL_ALIGNMENTS.MIDDLE}
            marginAroundElement={8}
            verticalAlignment={TOOLTIP_VERTICAL_ALIGNMENTS.TOP}
        />
    );
};